import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import { FaHeart, FaShoppingCart } from "react-icons/fa";
import { base_url } from "../utils/axiosConfig";

const CategoryProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { categoryId } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchProductsByCategory = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${base_url}/productss/category/${categoryId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setProducts(data);
        // Set category name based on first product's category (assuming API returns category info)
        setCategoryName(data[0]?.category?.name || "Category");
      } catch (error) {
        console.error("Error fetching products by category:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProductsByCategory();
  }, [categoryId]);

  const handleProductClick = (id) => {
    navigate(`/product-details/${id}`);
  };

  if (loading) return <p className="text-center mt-5">Loading...</p>;
  if (error)
    return <p className="text-center mt-5 text-danger">Error: {error}</p>;

  return (
    <Container class1="py-5 bg-white">
      <div className="row d-flex flex-wrap justify-content-md-start justify-content-center">
        <div className="col-12">
          <h3
            className="section-heading text-start"
            style={{ fontSize: "24px", fontWeight: "600", marginTop: "20px" }}
          >
            {categoryName} Products
          </h3>
        </div>
        {products.length > 0 ? (
          products.map((product, index) => (
            <div
              key={index}
              className="col-md-2 col-sm-4 col-6 d-flex justify-content-md-start justify-content-center"
            >
              <div
                className="text-center"
                style={{
                  width: "200px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  className="product-img-container"
                  style={{
                    backgroundColor: "#f0f0f0",
                    width: "200px",
                    height: "280px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    borderRadius: "8px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleProductClick(product._id)}
                >
                  <img
                    src={product.images[0] || "/placeholder.png"}
                    className="img-fluid"
                    alt={product.name}
                    style={{
                      width: "133px",
                      height: "144px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    className="icon-container"
                    style={{ position: "absolute", top: "10px", right: "10px" }}
                  >
                    <FaHeart
                      className="wishlist-icon"
                      style={{ marginRight: "10px" }}
                    />
                    <FaShoppingCart className="cart-icon" />
                  </div>
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#555",
                    marginTop: "12px",
                  }}
                >
                  {product.name}
                </div>
                <div
                  style={{ fontSize: "11px", color: "gray", marginTop: "6px" }}
                >
                  {product.description}
                </div>
                <div className="d-flex align-items-center gap-2 mt-2">
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#000",
                    }}
                  >
                    ${product.price}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "gray",
                      textDecoration: "line-through",
                    }}
                  >
                    ${product.price + (product.discount || 0)}
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "green",
                      fontWeight: "500",
                    }}
                  >
                    ({product.discount || 0}% OFF)
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <p className="text-gray-600">
              No products found for this category.
            </p>
          </div>
        )}
      </div>
    </Container>
  );
};

export default CategoryProductsPage;
